<div class="container-md">
  <div class="form-group">
    <form name="login">
      <h4 class="sign-in-dialog-centered my-4">
        {{ 'IDS_WELCOME_BACK' | translate }}
      </h4>
      <div class="mx-lg-4">
        <div class="row pe-3">
          <div class="col-6">
            <label class="fw-bold" for="username"
              >{{ 'IDS_USERNAME_EMAIL' | translate }}</label
            >
          </div>
        </div>
        <input
          class="sign-in-dialog-input"
          type="email"
          id="username"
          name="username"
          autocomplete="email"
          placeholder="{{ 'IDS_USERNAME_EMAIL' | translate }}"
          [(ngModel)]="userCredentials.username"
          (keydown.enter)="login()"
        /><br />
        @if(isUsernameEmpty){
        <div class="row pe-3 d-flex justify-content-center">
          <div class="error-label" role="alert"
            >{{ 'IDS_FIELD_REQUIRED' | translate }}</div
          >
        </div>
        }
        <div class="row mt-3 pe-3">
          <div class="col-6">
            <label class="fw-bold" for="password">{{ 'IDS_PASSWORD' | translate }}</label>
          </div>
          <div class="col-6 text-end">
            <a
              tabindex="-1"
              class="fnButton"
              href="#"
              (click)="$event.preventDefault(); openReset()"
            >
              {{ 'IDS_RESET' | translate }}
          </a>
          </div>
        </div>
        <input
          class="sign-in-dialog-input"
          type="password"
          id="password"
          name="password"
          autocomplete="current-password"
          placeholder="{{ 'IDS_PASSWORD' | translate }}"
          [(ngModel)]="userCredentials.password"
          (keydown.enter)="login()"
        /><br />
        @if(isPasswordEmpty){
        <div class="row pe-3 d-flex justify-content-center">
          <div class="error-label" role="alert"
            >{{ 'IDS_FIELD_REQUIRED' | translate }}</div
          >
        </div>
        }
      </div>
      <div class="d-flex justify-content-center mt-5">
        <button
          tabindex="-1"
          class="btn-gold fw-bold px-3 text-uppercase"
          type="button"
          (click)="login()"
        >
          {{ 'IDS_ENTER' | translate }}
        </button>
      </div>
      <div class="d-flex justify-content-center mb-4">
        @if(loginError){
        <div class="error-label" role="alert"
          >{{ 'IDS_INCORRECT_CREDENTIALS' | translate }}</div
        >
        } @if(notActivated){
        <div class="error-label" role="alert">{{ 'IDS_CHECK_EMAIL' | translate }}</div>
        }
      </div>
      <div class="d-flex justify-content-center mt-2">
        <button tabindex="-1" type="button" class="newAccount magic-link-cta fw-bold" (click)="sendMagicLink()">
          {{ 'IDS_LOGIN_WITH_MAGIC_LINK' | translate }}
        </button>
      </div>
      <div class="d-flex justify-content-center mb-4">
        @if(magicLinkSent){
        <output class="text-success">{{ 'IDS_MAGIC_LINK_SENT' | translate }}</output>
        }
      </div>
      <div class="d-flex justify-content-center">
        <div class="sign-in-dialog-centered text-muted"
          >{{ 'IDS_NOT_REGISTERED_QUESTION' | translate }}</div
        >
      </div>
      <div class="d-flex justify-content-center">
        <button
          tabindex="-1"
          type="button"
          class="newAccount"
          (click)="changePageHandler()"
        >
          {{ 'IDS_CREATE_NEW_ACCOUNT' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
